import axios from 'axios'
import { ROOT_URL } from '../utils/helpers'

import {
  UPDATE_CALCULATOR,
  DISPLAY_VARIATIONS,
  UPDATE_COMPONENT_LIST,
  FETCH_LOGISTICS_AMOUNT,
  FETCH_LOGISTICS_AMOUNT_SUCCESS,
  FETCH_LOGISTICS_AMOUNT_ERROR,
  FETCH_DURATIONS,
  FETCH_DURATIONS_SUCCESS,
  FETCH_DURATIONS_ERROR,
  UPDATE_CALCULATOR_PRICE,
  CLEAR_CALCULATOR,
  FETCH_ALL_PROVINCES_SUCCESS,
  FETCH_ALL_PROVINCES_ERROR,
  FETCH_PRODUCT_SUCCESS,
  FETCH_PRODUCT_ERROR,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_ERROR
} from './types'

// Action creator that passes the step and data to be updated
export function updateCalculator (step, data) {
  return {
    type: UPDATE_CALCULATOR,
    payload: {
      data,
      step
    }
  }
}

// Action creator that is used to display the variations for Step 3/4
// name - component/variation name
export function displayVariations (name) {
  return {
    type: DISPLAY_VARIATIONS,
    payload: name
  }
}

// Action creator that is used to update current component list
// in configurator
export function updateComponentList (components) {
  return {
    type: UPDATE_COMPONENT_LIST,
    payload: components
  }
}

// Get the logistics amount based on the zipcode
export function fetchLogisticsAmount (id) {
  return function (dispatch) {
    dispatch({
      type: FETCH_LOGISTICS_AMOUNT
    })

    localStorage.setItem('id_province', id);

    // let searchParams = new URLSearchParams(window.location.search);
    let sport = window.location.pathname.split('/')[2]

    axios.get(`${ROOT_URL}/logistics?id_province=${id}&id_package_variant=${localStorage.getItem('id_package_variant')}&sport=${sport}`)
    // axios.get(`${ROOT_URL}/logistics?id_province=70`)
      .then(response => {
        // If request is succesful
        // Update state with response info
        dispatch({
          type: FETCH_LOGISTICS_AMOUNT_SUCCESS,
          payload: response.data
        })
      })
      .catch(error => {
        // If request fails
        if (error.response) {
          const errors = error.response.data.errors
          dispatch({
            type: FETCH_LOGISTICS_AMOUNT_ERROR,
            payload: errors
          })
        }
      })
  }
}

// Get the duration details based on the price
export function fetchDurations (amount, callback) {
  let sport = window.location.pathname.split('/')[2]

  return function (dispatch) {
    let url = ''
    if (amount) {
      url = `${ROOT_URL}/durations?amount=${localStorage.getItem('rentAmount')}&id_package_variant=${localStorage.getItem('id_package_variant')}&sport=${sport}&id_province=${localStorage.getItem('id_province')}`
    } else {
      url = `${ROOT_URL}/durations`
    }

    dispatch({
      type: FETCH_DURATIONS
    })

    axios.get(url)
      .then(response => {
        // If request is succesful
        // Update state with response info
        response = response.data
        dispatch({
          type: FETCH_DURATIONS_SUCCESS,
          payload: response
        })
        callback(response.data)
      })
      .catch(error => {
        // If request fails
        if (error.response) {
          const errors = error.response.data.errors
          dispatch({
            type: FETCH_DURATIONS_ERROR,
            payload: errors
          })
        }
      })
  }
}

// Update all the prices in the calculator based on the duration
export function updateCalculatorPrice (coefficient, average) {
  return {
    type: UPDATE_CALCULATOR_PRICE,
    payload: {
      coefficient,
      average
    }
  }
}

// Reinitializes the calculator to the default state
export function clearCalculator (callback) {
  return function (dispatch) {
    dispatch({
      type: CLEAR_CALCULATOR
    })
    callback()
  }
}

// Get list of provinces
export function fetchProvinces () {
  return function (dispatch) {
    axios.get(`${ROOT_URL}/provinces`)
      .then(response => {
        // If request is succesful
        // Update state with response info
        dispatch({
          type: FETCH_ALL_PROVINCES_SUCCESS,
          payload: response.data
        })
      })
      .catch(error => {
        // If request fails
        if (error.response) {
          const errors = error.response.data.errors
          dispatch({
            type: FETCH_ALL_PROVINCES_ERROR,
            payload: errors
          })
        }
      })
  }
}

// Get a product
export function fetchProduct (id, callback) {
  return function (dispatch) {
    axios.get(`${ROOT_URL}/products/${id}`)
      .then(response => {
        // If request is succesful
        // Update state with response info
        response = response.data
        dispatch({
          type: FETCH_PRODUCT_SUCCESS,
          payload: response
        })
        callback(response.data)
      })
      .catch(error => {
        // If request fails
        if (error.response) {
          const errors = error.response.data.errors
          dispatch({
            type: FETCH_PRODUCT_ERROR,
            payload: errors
          })
        }
      })
  }
}

// Get all products
export function fetchProducts (callback) {
  return function (dispatch) {
    axios.get(`${ROOT_URL}/products`)
      .then(response => {
        // If request is succesful
        // Update state with response info
        response = response.data
        dispatch({
          type: FETCH_PRODUCTS_SUCCESS,
          payload: response
        })
        callback(response.data)
      })
      .catch(error => {
        // If request fails
        if (error.response) {
          const errors = error.response.data.errors
          dispatch({
            type: FETCH_PRODUCTS_ERROR,
            payload: errors
          })
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/calculator.js